import { useToast } from '@/context/ToastContext';
import routes from '@constants/routes';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, useRouteMatch } from 'react-router-dom';

/**
 * A PATH NO ROUTE SERVES SAYS SO AND MOVES ON (#1199). A typo, an old bookmark or a removed page
 * matched nothing in `MainRouter` and drew an empty page: no layout, no menu, no way back. A path
 * under an audit goes to that audit's overview, where the dashboard's own guards take over (a
 * section the caller may not open, an audit that is gone); any other goes to the audit list.
 *
 * The notice goes through `useToast`, not the `emitToast` bridge: on a fresh load this mounts in
 * the app's first render, and its effect runs before the provider's registers the bridge.
 */
export function UnknownPathRedirect() {
  const auditMatch = useRouteMatch<{ id: string }>('/dashboard/:id(\\d+)');
  const { t } = useTranslation('dashboard', { keyPrefix: 'global' });
  const { showToast } = useToast();

  useEffect(() => {
    showToast({ type: 'warning', message: t('page_not_found') });
  }, [showToast, t]);

  return (
    <Redirect to={auditMatch ? routes.dashboard.overview(auditMatch.params.id) : routes.audits} />
  );
}
